import { CopiesCurrFilter } from '@apps/bckp/models';
import { OData } from '@common/api/qs';

export class ODataBckpCopiesCurr extends OData
{
    private _filter: CopiesCurrFilter;
    private field4Filter: string[] = [
        'server',
        'policyName',
        'residence',
        'slpName'
    ];
    get filter ()
    {
        return this._filter;
    }

    constructor (incSize: number, filter?: CopiesCurrFilter)
    {
        super(incSize);

        if (filter !== undefined)
        {
            this.processFilter(filter);
        }

        this.qs = this.getQueryString();
    }

    private processFilter (filter: CopiesCurrFilter)
    {
        this._filter = new CopiesCurrFilter();
        Object.assign(this._filter, filter);

        this.pushValue('since', filter.since);
        this.pushValue('until', filter.until);

        this.field4Filter.forEach((f: string) =>
        {
            if (filter[f])
            {
                this.pushValue('terms', `${f}:${filter[f]}`);
            }
        });
    }
}
